import {currentPage} from '../common/layout';

currentPage.pageInit = ($page, pageData, pageId) => {

}